import { render, staticRenderFns } from "./DraftEditor.vue?vue&type=template&id=1d485166"
import script from "./DraftEditor.vue?vue&type=script&lang=js"
export * from "./DraftEditor.vue?vue&type=script&lang=js"
import style0 from "./DraftEditor.vue?vue&type=style&index=0&id=1d485166&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports